package com.meistercharts.charts.pv.stringsPlanning

import com.meistercharts.charts.pv.roofPlanning.ModuleArea.ModuleAreaId
import com.meistercharts.charts.pv.roofPlanning.ModuleIndex
import kotlinx.serialization.Serializable

@Serializable
data class ModuleReference(
  val moduleAreaId: ModuleAreaId,
  val moduleIndex: ModuleIndex,
)
